import React, { Fragment, useState, useEffect } from "react";
import Resource from "./Resource";
import ResourceTopicFilter from "./ResourceTopicFilter";
import HelpBanner from "./HelpBanner";

export default function TopicBucket({
  resources,
  userList,
  handleUserListUpdate,
  topics,
  setTopics,
  isMobile,
}) {
  const isDev = window.location.hostname.includes("localhost");
  const INITIAL_RESULTS_COUNT = 10;
  const SHOW_MORE_COUNT = 10;
  const HELP_BANNER_INTERVAL = 12;
  const [numResults, setNumResults] = useState(INITIAL_RESULTS_COUNT);
  const [shownResources, setShownResources] = useState(resources.slice(0, numResults));
  const [printId, setPrintId] = useState(null);

  // if numResults changes, update the number of results to show
  useEffect(() => {
    setShownResources(resources.slice(0, numResults));
  }, [resources, numResults]);

  const handleClick = () => {
    setNumResults((numResults) => numResults + SHOW_MORE_COUNT);
  };

  const handlePrint = (resourceId) => {
    setPrintId(resourceId);
    if (!isDev) {
      gtag("event", "print", {});
    }

    setTimeout(() => {
      window.print();
      setPrintId(null);
    }, 1000); // Adjust the delay time as needed
  };

  return (
    <div className={`wrapper ${!printId ? "" : "print-only"}`}>
      {topics.length > 1 && (
        <ResourceTopicFilter topics={topics} setTopics={setTopics} isMobile={isMobile} />
      )}
      <ul className="resource-bucket">
        {shownResources.map((resource, index) => {
          return (
            <Fragment key={`${resource.item.id}`}>
              {(index + 1) % HELP_BANNER_INTERVAL === 0 && (
                <li>
                  <HelpBanner />
                </li>
              )}

              <li className={`${resource.item.id === printId ? "print-only" : ""}`}>
                <Resource
                  resourceObject={resource}
                  userList={userList}
                  handleUserListUpdate={handleUserListUpdate}
                  handlePrint={handlePrint}
                  isMobile={isMobile}
                />
              </li>
            </Fragment>
          );
        })}
        {resources.length > INITIAL_RESULTS_COUNT && numResults < resources.length && (
          <div className="resource-list-load-more">
            <button className="button button--l more-results" onClick={handleClick}>
              See More Results
            </button>
          </div>
        )}
      </ul>
      {resources.length === 0 && (
        <div className="content content--wide">
          <div className="resource-list resource-buckets">
            <div className="resource-list-header">
              <span className="resource-list-no-results h3">
                No results for these words and filter settings.
                <br />
                Try changing filters if in use, or <a href="/#topics">start a new search</a> with
                different words.
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
